export enum EOverallOrderStatus {
	IN_PROGRESS = 'in_progress',
	PARTLY_SHIPPED = 'partly_shipped',
	SHIPPED = 'shipped',
	CANCELLED = 'cancelled',
	PARTLY_RETURNED = 'partly_returned',
	RETURNED = 'returned',
	REFUNDED = 'refunded',
	READY_FOR_PICKUP = 'ready_for_pickup',
	READY_FOR_PARTIAL_PICKUP ='ready_for_partial_pickup',
	PICKED_UP = 'picked_up',
	PARTLY_PICKED_UP = 'partly_picked_up',
	CANCELED = 'canceled'
}

export enum EStatus {
	NEW = 'new',
	OPEN = 'open',
	CANCELLED = 'cancelled',
	COMPLETED = 'completed',
	IN_REVIEW = 'in_review',
	BEING_PROCESSED = 'being_processed',
}

export enum EConfirmationStatus {
	NOT_CONFIRMED = 'not_confirmed',
	CONFIRMED = 'confirmed',
}

export enum EShippingStatus {
	NOT_SHIPPED = 'not_shipped',
	SHIPPED = 'shipped',
	READY_FOR_PICKUP = 'ready-for-pickup',
	READY_FOR_PARTIAL_PICKUP = 'ready-for-partial-pickup',
	PARTIALLY_PICKED_UP = 'partly-picked-up',
	PICKED_UP = 'picked-up',
	DELIVERED = 'delivered',
	DELIVERING = 'delivering',
}
